import { render, staticRenderFns } from "./storeOrderUpManage.vue?vue&type=template&id=08ad6db3&scoped=true"
import script from "./storeOrderUpManage.vue?vue&type=script&lang=js"
export * from "./storeOrderUpManage.vue?vue&type=script&lang=js"
import style0 from "./storeOrderUpManage.vue?vue&type=style&index=0&id=08ad6db3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ad6db3",
  null
  
)

export default component.exports